module.exports = __webpack_public_path__ + "img/BikeNow.4fdc1d4c.svg";